import { memo, useMemo } from 'react';
import styled, { type CSSObject } from '@emotion/styled';

import { cleanThemeHTML } from '../../lib/cleanUserInput';
import { themeFont } from '../../lib/themeFont';
import useThemeStyles from '../../lib/useThemeStyles';

const FooterText = styled("div")`
  line-height: 1.75;
  ${themeFont('tiny')}
  margin: 12px 0;
  text-align: center;
  & a {
    ${(props): CSSObject | undefined => props.theme.components.Link};
    text-decoration: underline;
  }
`;
const Link = styled("a")`
  ${themeFont('tiny')};
  ${(props): CSSObject | undefined => props.theme.components.Link};
`;

const style = { textDecoration: 'underline' };

const PrivacyPolicy = styled("p")`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  ${themeFont('tiny')};
  ${(props): CSSObject | undefined => props.theme.components.Link};
`;

function toggleCMPModal() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).UnionConsentManagement.togglePreferencesModal();
}

function ThemeAttribution() {
  const themeStyles = useThemeStyles();
  // allow only link tags in the response
  const footerContent = useMemo(
    () =>
      themeStyles.config?.footerAttribution
        ? themeStyles.config?.footerAttribution
        : 'Created on The Knot',
    [themeStyles]
  );
  const dangerouslySetInnerHTML = useMemo<{
    __html: string;
  }>(() => ({ __html: cleanThemeHTML(footerContent) }), [footerContent]);

  return (
    <FooterText>
      <div dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
      <br />
      {'Getting married? '}
      <Link
        href="https://www.theknot.com/gs/wedding-websites"
        rel="noopener noreferrer"
        style={style}
        target="_blank"
      >
        Create your wedding website for free.
      </Link>
      <PrivacyPolicy onClick={toggleCMPModal}>
        Your Privacy Choices
      </PrivacyPolicy>
    </FooterText>
  );
}

export default memo(ThemeAttribution);
